import * as React from "react";

export const unwrap = (Component) => ({ data, ...rest }) => (
  <Component {...data?.wagtail} {...rest} />
);
